import React, { useState } from 'react';

import { Button, Mark, Popover, Table, Text } from '@mantine/core';

import { Type } from '@/types/object';

import IconDelete from '@/shared/uikit/assets/icons/IconDelete.svg?react';
import IconEdit from '@/shared/uikit/assets/icons/IconEdit.svg?react';

import { IconCheck, IconX } from '@tabler/icons-react';

type ObjectTypesItemProps = {
	objectType: Type;
	handleEdit: (objectType: Type) => void;
	handleDelete: (id: number) => Promise<void>;
};

const ObjectTypesItem: React.FC<ObjectTypesItemProps> = ({
	objectType,
	handleEdit,
	handleDelete,
}) => {
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);

	return (
		<Table.Tr key={objectType?.id}>
			<Table.Td>
				<Text size="md" fw={600} lts="normal">
					{objectType.name}
				</Text>
			</Table.Td>
			<Table.Td>
				<Text size="md" fw={600} c="dimmed">
					{objectType.description}
				</Text>
			</Table.Td>
			<Table.Td>
				<Text size="md" fw={600} c="dimmed">
					{objectType.kind}
				</Text>
			</Table.Td>
			<Table.Td>
				<Mark
					color="#E6F7FF"
					fz={14}
					pt={3}
					pb={3}
					pr={6}
					pl={6}
					c="blue"
					style={{ border: '1px solid #91D5FF', borderRadius: '5px' }}
				>
					{objectType.id}
				</Mark>
			</Table.Td>
			<Table.Td>
				<Button.Group display="flex" style={{ justifyContent: 'center' }}>
					<Button
						variant="transparent"
						size="compact-sm"
						radius="sm"
						color="balck"
						onClick={() => handleEdit(objectType)}
					>
						<IconEdit fontSize={20} color="#667085" cursor="pointer" />
					</Button>
					<Popover
						position="top"
						withArrow
						shadow="md"
						opened={isPopoverOpen}
						onChange={setIsPopoverOpen}
					>
						<Popover.Target>
							<Button
								variant="transparent"
								size="compact-sm"
								radius="sm"
								color="balck"
								onClick={() => setIsPopoverOpen((prev) => !prev)}
							>
								<IconDelete fontSize={20} color="#667085" cursor="pointer" />
							</Button>
						</Popover.Target>
						<Popover.Dropdown p={8}>
							<Text size="xs">
								<Text ta="center" fz={13}>
									Удалить?
								</Text>
								<Button.Group mt={3}>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										onClick={() => handleDelete(objectType?.id)}
									>
										<IconCheck size={16} />
									</Button>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										color="red"
										onClick={() => setIsPopoverOpen(false)}
									>
										<IconX size={16} />
									</Button>
								</Button.Group>
							</Text>
						</Popover.Dropdown>
					</Popover>
				</Button.Group>
			</Table.Td>
		</Table.Tr>
	);
};

export default ObjectTypesItem;
